<template>
  <div>
    <vue-good-table :columns="columns" :rows="offerings" :sort-options="{
      enabled: false,
    }" :pagination-options="{
      enabled: true,
      perPageDropdown: [15],
      dropdownAllowAll: true,
      perPage: 15,
      mode: 'records',
    }" :search-options="{
      enabled: true,
      placeholder: 'Search by a product name',
      searchFn: onSearch,
    }" :select-options="{
        enabled: true,
        selectOnCheckboxOnly: true,
        selectionInfoClass: 'selection-grid',
        selectionText: 'products selected',
        clearSelectionText: 'Reset',
        disableSelectInfo: false,
      }" @on-selected-rows-change="this.onSelectChangeFunc" styleClass="vgt-table condensed">
      <div slot="selected-row-actions">
        <button type="button" class="btn flat-blue-btn" @click="requestSubscriptions()">
          Request Licenses
        </button>
      </div>
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.label == 'Badge'">
          <img class="img-container" :src="props.row.icon" />
        </span>
        <span v-else-if="props.column.field == 'name'">
          <p class="common-style name">{{ props.row.productName }}</p>
        </span>
        <span v-else-if="props.column.field == 'access' && props.row.subscriptionId">
          <a class="common-style access" target="_blank" :href="getRedirect(props.row.productLineCode)">
            {{ props.row.subscriptionId }}
          </a>
          <span class="tooltiptext">{{ `expires ${props.row.expirationDate}` }}</span>
        </span>
        <span v-else-if="
          props.column.field == 'access' && !props.row.subscriptionId
        ">
          <p class="common-style access">-</p>
        </span>
        <span v-else-if="props.column.field == 'productDivision'">
          <p class="common-style division">
            {{ props.row.productDivision ? props.row.productDivision : " - " }}
          </p>
        </span>
        <span v-else-if="
          props.column.field == 'productInfoUrl' && props.row.productInfoUrl
        ">
          <a class="common-style" target="_blank" :href="props.row.productInfoUrl">Product information</a>
        </span>
        <span v-else-if="
          props.column.field == 'productInfoUrl' && !props.row.productInfoUrl
        ">
          <p class="common-style">-</p>
        </span>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
import { VueGoodTable } from "vue-good-table";
export default {
  name: "OfferingTable",
  components: {
    VueGoodTable,
  },
  props: {
    offerings: Array,
    columns: Array,
    onSelectChangeFunc: { type: Function, default: function () { } },
  },

  methods: {
    onSearch(row, col, cellValue, searchTerm) {
      return row.productName.toLowerCase().includes(searchTerm.toLowerCase());
    },
    getRedirect(productLineCode) {
      return `${process.env.VUE_APP_MANAGE_REDIRECT}?filter=%7B"offeringPlc"%3A"${productLineCode}"%7D`;
    },
    requestSubscriptions() {
      this.$emit("handleClick");
    },
  },
};
</script>
<style scoped>
.img-container {
  height: 25px;
  width: 25px;
  margin-inline-start: 10px;
}

.common-style {
  text-align: left;
  margin-left: 15px;
  font-size: 14px;
}

.name {
  width: 400px;
}

.access {
  width: 150px;
}

.division {
  width: 100px;
}

.selection-grid {
  color: green;
}

.tooltiptext {
  visibility: hidden;
  background-color: black;
  color: #fff;
  border-radius: 6px;
  position: relative;
  margin-left: -150px;
  top: -25px;
  padding: 5px;
}

.access:hover+.tooltiptext {
  visibility: visible;
}

.vgt-wrap__footer vgt-clearfix {
  border: 10px solid #fff;
  background: green;
  margin-top: 15px;
}
</style>
